const english = {
  title: 'english',
  name: 'EN',
  userMenu: {
    exit: 'Log out',
  },
  authForm: {
    signupTitle: 'Registration',
    signinTitle: 'Authentication',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    signupButton: 'Sign up',
    signinButton: 'Sign in',
    signupQuestion: 'Have you got an account?',
    signinQuestion: "Haven't got an account yet?",
    signupLink: 'Sign in',
    signinLink: 'Sign up',
  },
  sidebarModal: {
    createButton: 'Create',
    cancelButton: 'Cancel',
  },
  projectsPage: {
    pageTitle: 'Projects',
    addButton: 'Create project',
    projectCollection:
      'This folder is empty. Use "Create project" button to add new one',
  },
  projectsPageForm: {
    formTitle: 'Project creation',
    projectName: 'Project name',
    projectDescription: 'Project description',
  },
  projectPage: {
    addSprintButton: 'Create sprint',
    addMembersButton: 'Add members',
    sprintCollection:
      'This folder is empty. Use "Create sprint" button to add new one',
  },
  projectPageSidebar: {
    goBack: 'Show projects',
    addProjectButton: 'Create project',
  },
  projectPageForm: {
    formTitle: 'Sprint creation',
    sprintName: 'Sprint name',
    prevDays: 'Previous days',
    startDate: 'Start date',
    expireDate: 'Expire date',
    duration: 'Duration',
  },
  addMembersForm: {
    formTitle: 'Add members',
    email: 'Enter your email',
    members: 'Added users:',
  },
  sprintPageSidebar: {
    goBack: 'Show sprints',
    addSprintButton: 'Create sprint',
  },
  sprintPageHeader: {
    addTaskButton: 'Create task',
    taskName: 'Task',
    plannedHours: 'Scheduled hours',
    spentHoursPerDay: 'Spent  hours / day',
    spentHoursTotally: 'Spent hours',
  },
  sprintPageForm: {
    formTitle: 'Task creation',
    taskName: 'Task name',
    plannedHours: 'Scheduled hours',
  },
  sprintPage: {
    taskCollection:
      'This folder is empty. Use "Create task" button to add new one',
    editProjectName: 'Enter new name',
  },
};

export { english };
